import { PropsWithChildren, useEffect, useState } from 'react'
import { Header } from './Header'
import { Aside } from './Aside'
import { Modal } from '../Modal'
import { FloatMenu } from '../FloatMenu'
import sonorizaLogo from '@/assets/sonoriza-s.png'

interface LayoutProps extends PropsWithChildren {
  isError?: boolean
}

export function Layout({ children, isError }: LayoutProps) {
  const [isCompactViewport, setIsCompactViewport] = useState(false)
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(true)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1250px)')

    const syncSideMenu = (matchesCompactViewport: boolean) => {
      setIsCompactViewport(matchesCompactViewport)
      setIsSideMenuOpen(!matchesCompactViewport)
    }

    syncSideMenu(mediaQuery.matches)

    const handleViewportChange = (event: MediaQueryListEvent) => {
      syncSideMenu(event.matches)
    }

    mediaQuery.addEventListener('change', handleViewportChange)

    return () => {
      mediaQuery.removeEventListener('change', handleViewportChange)
    }
  }, [])

  return (
    <div className="relative">
      <Modal />
      <FloatMenu />
      <Header
        isError={isError}
        isSideMenuOpen={isSideMenuOpen}
        onToggleSideMenu={() => setIsSideMenuOpen((current) => !current)}
      />
      <div className="pt-20 flex h-screen bg-gray-200 relative">
        <Aside
          isCompactViewport={isCompactViewport}
          isError={isError}
          isOpen={isSideMenuOpen}
          onClose={() => setIsSideMenuOpen(false)}
        />

        {isCompactViewport && isSideMenuOpen && (
          <button
            aria-label="Close side menu overlay"
            className="fixed inset-x-0 bottom-0 top-20 z-30 bg-gray-950/30"
            onClick={() => setIsSideMenuOpen(false)}
            title="Close side menu"
          />
        )}

        <main
          className={`min-w-0 flex-1 py-10 px-10 transition-[margin] duration-300 base:px-6 md:px-4 ${
            isSideMenuOpen && !isCompactViewport ? 'ml-[350px]' : 'ml-0'
          }`}
        >
          {children}
        </main>
        <button
          title="Go to top"
          onClick={() => {
            window.scrollTo(0, 0)
          }}
        >
          <img
            src={sonorizaLogo}
            alt="sonoriza-s"
            className="w-28 h-28 mt-auto p-4 fixed right-0 bottom-0"
          />
        </button>
      </div>
    </div>
  )
}
